import { render, staticRenderFns } from "./PortalWidget.vue?vue&type=template&id=1c557882&scoped=true"
import script from "./PortalWidget.vue?vue&type=script&lang=js"
export * from "./PortalWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c557882",
  null
  
)

export default component.exports